module.exports = __webpack_public_path__ + "img/document_download.1aed3a30.svg";